import KeyValueList from './key-value-list';

export type { KeyValueItem } from './key-value-list';

export default KeyValueList;
